import React, { useMemo, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { redeemInvite } from "../api/invitesAPI";

const InviteSignup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("token") ?? "";
  }, [location.search]);

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (!token) {
      setError("Invite token is missing or invalid.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await redeemInvite({ token, name, password });
      setSuccess(true);
      setTimeout(() => navigate("/sign-in"), 2000);
    } catch (err) {
      const message = err.response?.data?.message || (err instanceof Error ? err.message : null);
      setError(message || "Unable to redeem invite.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="signup-page-background"
      style={{
        backgroundColor: "#f7f7f7",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <header className="shadow-sm py-3 px-24 d-flex align-items-center">
        <Link to="/" className="d-inline-block">
          <img
            src="/assets/images/logo_neg.png"
            alt="Logo"
            style={{ height: "40px", objectFit: "contain" }}
          />
        </Link>
      </header>
      <section
        className="auth forgot-password-page d-flex justify-content-center pt-4 px-3"
        style={{ flex: 1, overflowY: "auto", minHeight: 0 }}
      >
        <div className="d-flex flex-column">
          <div className="p-32 m-32 max-w-500-px w-100 border rounded-2 text-center bg-white">
            {!success ? (
              <>
                <div className="text-center p-16 d-flex flex-column align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                    style={{ width: "90px", height: "90px" }}
                  >
                    <Icon icon="mdi:account-plus" style={{ fontSize: "54px" }} />
                  </div>
                </div>
                <h5 className="mb-24">Accept your invitation</h5>
                <p className="mb-32 text-secondary-light text-lg">
                  Create your Samurai account password to join your team.
                </p>
                <form onSubmit={submit}>
                  <div className="mb-3 text-start">
                    <label className="form-label">Full name</label>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3 text-start">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      minLength={8}
                    />
                  </div>
                  {error && <div className="text-danger text-start">{error}</div>}
                  <button
                    type="submit"
                    className="btn btn-primary text-sm btn-sm px-12 py-12 w-50 radius-12 mt-32"
                    disabled={submitting}
                  >
                    {submitting ? "Creating..." : "Join Samurai"}
                  </button>
                  <div className="text-center mt-24">
                    <Link to="/sign-in" className="text-primary-600 fw-bold">
                      Back to Sign In
                    </Link>
                  </div>
                </form>
              </>
            ) : (
              <div className="text-center">
                <div className="text-center p-16 d-flex flex-column align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                    style={{ width: "90px", height: "90px" }}
                  >
                    <Icon
                      icon="mdi:check-circle-outline"
                      style={{ fontSize: "54px" }}
                    />
                  </div>
                </div>
                <h5 className="mb-12">Welcome to Samurai!</h5>
                <p className="text-secondary-light mb-32 text-lg">
                  Your account has been created. Redirecting you to sign in...
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <footer className="text-center py-3">
        <small className="text-white">
          © {new Date().getFullYear()} Samurai CMMS
        </small>
      </footer>
    </div>
  );
};

export default InviteSignup;
